import lscache from "lscache";

import {PROFILE_PICTURE_AUTH_KIND} from "../../km_app/constants/storage_keys";
import {IUserProfile} from "../interfaces/IUserProfile";

type IProfilePictureFields = Partial<Pick<IUserProfile, "picture">>;

export type ProfilePictureAuthKind = "sso" | "email";

export const setProfilePictureAuthKind = (kind: ProfilePictureAuthKind): void => {
    lscache.set(PROFILE_PICTURE_AUTH_KIND, kind);
};

export const clearProfilePictureAuthKind = (): void => {
    lscache.remove(PROFILE_PICTURE_AUTH_KIND);
};

export const getProfilePictureAuthKind = (): ProfilePictureAuthKind | null => {
    const kind = lscache.get(PROFILE_PICTURE_AUTH_KIND);

    return kind === "sso" || kind === "email" ? kind : null;
};

export const getProfileAvatarUrl = (profile?: IProfilePictureFields | null): string | null => {
    return profile?.picture || null;
};

export const getProfilePictureCaptured = (
    profile?: IProfilePictureFields | null,
    authKind: ProfilePictureAuthKind | null = getProfilePictureAuthKind()
): boolean | null => {
    if (authKind === "email") return null;
    if (authKind === "sso") return Boolean(getProfileAvatarUrl(profile));

    return getProfileAvatarUrl(profile) ? true : null;
};
import lscache from "lscache";

import {PROFILE_PICTURE_AUTH_KIND} from "../../km_app/constants/storage_keys";
import {IUserProfile} from "../interfaces/IUserProfile";

type IProfilePictureFields = Partial<Pick<IUserProfile, "picture">>;

export type ProfilePictureAuthKind = "sso" | "email";

export const setProfilePictureAuthKind = (kind: ProfilePictureAuthKind): void => {
    lscache.set(PROFILE_PICTURE_AUTH_KIND, kind);
};

export const clearProfilePictureAuthKind = (): void => {
    lscache.remove(PROFILE_PICTURE_AUTH_KIND);
};

export const getProfilePictureAuthKind = (): ProfilePictureAuthKind | null => {
    const kind = lscache.get(PROFILE_PICTURE_AUTH_KIND);

    return kind === "sso" || kind === "email" ? kind : null;
};

export const getProfileAvatarUrl = (profile?: IProfilePictureFields | null): string | null => {
    return profile?.picture || null;
};

export const getProfilePictureCaptured = (
    profile?: IProfilePictureFields | null,
    authKind: ProfilePictureAuthKind | null = getProfilePictureAuthKind()
): boolean | null => {
    if (authKind === "email") return null;
    if (authKind === "sso") return Boolean(getProfileAvatarUrl(profile));

    return getProfileAvatarUrl(profile) ? true : null;
};
